import { guestConstants } from "../constants";

export const guestActions = {
  login,
  loginSuccess,
  loginFailure,
  signup,
  signupSuccess,
  signupFailure,

  checkEmailExist,
  checkEmailExistSuccess,
  checkEmailExistFailure,

  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordFailure,

  validateSetPasswordToken,
  validateSetPasswordTokenSuccess,
  setPassword,
  setPasswordSuccess,

};

//#region Signup/login/logout/user profile functions
function login(payload) {
  return {
    type: guestConstants.LOGIN_REQUEST,
    payload
  };
  // const {email, password} = loginData;
  // return dispatch => {
  //     dispatch(request({ email }));

  //     userService.login(email, password)
  //         .then(
  //             user => {
  //                 if (user.status === false) {
  //                     dispatch(failure(user.error.message));
  //                     dispatch(alertActions.error(user.error.message));
  //                 }
  //                 else {
  //                     dispatch(success(user));
  //                     window.location.href = '/assets';
  //                     //dispatch(alertActions.success('Login successful'));
  //                 }
  //             },
  //             error => {
  //                 //console.log("action error", error);
  //                 dispatch(failure(error));
  //                 dispatch(alertActions.error(error));

  //             }
  //         );
  // };

  // function request(user) { return { type: guestConstants.LOGIN_REQUEST, user } }
  // function success(user) { return { type: guestConstants.LOGIN_SUCCESS, user } }
  // function failure(error) {
  //     return { type: guestConstants.LOGIN_FAILURE, error }
  // }
}

function loginSuccess(payload) {
  return { type: guestConstants.LOGIN_SUCCESS, payload };
}

function loginFailure(error) {
  return { type: guestConstants.LOGIN_FAILURE, error };
}


function signup(payload) {
  return {
    type: guestConstants.REGISTER_REQUEST,
    payload
  };
}

function signupSuccess(payload) {
  return { type: guestConstants.REGISTER_SUCCESS, payload };
}

function signupFailure(error) {
  return { type: guestConstants.REGISTER_FAILURE, error };
}

function checkEmailExist(payload) {
  return {
    type: guestConstants.EMAIL_EXIST_REQUEST,
    payload
  };
}

function checkEmailExistSuccess(payload) {
  return { type: guestConstants.EMAIL_EXIST_SUCCESS, payload };
}

function checkEmailExistFailure(error) {
  return { type: guestConstants.EMAIL_EXIST_FAILURE, error };
}
//#endregion

//#region Set/Forget password functions
function forgotPassword(payload) {
  return {
    type: guestConstants.FORGOTPWD_REQUEST,
    payload
  };
}

function forgotPasswordSuccess(payload) {
  return { type: guestConstants.FORGOTPWD_SUCCESS, payload };
}

function forgotPasswordFailure(error) {
  return { type: guestConstants.FORGOTPWD_FAILURE, error };
}

function validateSetPasswordToken(token) {
  return {
    type: guestConstants.VALIDATE_PASSWORD_TOKEN_REQUEST,
    payload: { token }
  };
}

function validateSetPasswordTokenSuccess(payload) {
  return {
    type: guestConstants.VALIDATE_PASSWORD_TOKEN_SUCCESS,
    payload
  };
}

function setPassword(payload) {
  return {
    type: guestConstants.SET_PASSWORD_REQUEST,
    payload
  };
}

function setPasswordSuccess(payload) {
  return {
    type: guestConstants.SET_PASSWORD_SUCCESS,
    payload
  };
}
//#endregion